let User = {};

let tokenId = 'spicyToken';
let googleTokenId = 'googleToken';

//this is used to parse the profile
let urlBase64Decode = (str) => {
  let output = str.replace('-', '+').replace('_', '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw new Error('Illegal base64url string');
  }
  return window.atob(output);
};

User.getToken = () => {
  return window.localStorage.getItem(tokenId);
};

User.getGoogleToken = () => {
  return window.localStorage.getItem(googleTokenId);
};

let getProfile = () => {
  let token = User.getToken();
  let profile = null;
  if (token)
  {
    let encodedProfile = token.split('.')[1];
    if (encodedProfile)
      profile = JSON.parse(urlBase64Decode(encodedProfile));
  }
  return profile;
};

User.initialize = ({onChangeCb}) => {
  User.onChangeCb = onChangeCb;
}

User.startSession = (token) => {
  User.onChangeCb();
  window.localStorage.setItem(tokenId, token);
};

User.startGoogleSession = (token) => {
  window.localStorage.setItem(googleTokenId, token);
};


User.clearSession = () => {
  User.onChangeCb();
  window.localStorage.removeItem(tokenId);
};

User.getName = () => {
  let profile = getProfile();
  if (profile)      
    return profile.username;
  else
    return null;
};

User.getId = () => {
  let profile = getProfile();
  if (profile)      
    return profile.id;
  else
    return null;
};

User.isLoggedIn = () => {
  let id = User.getId();
  let username = User.getName();
  return username && username.length > 0 && id && id.length > 0;
};

module.exports = User;



// WEBPACK FOOTER //
// ./src/js/services/User.js